export const navigationKeys = {
  navigation: (locale: string) => ['navigation', locale],
};
